// extracted by mini-css-extract-plugin
export default {"list":"IconsList_list__X4XTv","item":"IconsList_item__zhSCv","icon":"IconsList_icon__4xuaS"};